//Inforamción del server cuando ejecuto en mi propia máquina
//const server = 'http://localhost:5000/';

//Información del server para cuando quiero ejecutar en red local
/*
const baseHost = window.location.href;
const splitHost = baseHost.split('/');
const subHost = splitHost[2].split(':');
const host = subHost[0];
const server = 'http://' + host + ':5000/';
*/

const server = 'https://backend.graficasdiamante.com/';

module.exports = {server}